import { ContactPackField } from "@jugl-web/rest-api";

export const CONTACT_PACK_TOOLS = ["collect_lead_info", "store_lead_info"];

export const RESERVED_VARIABLE_NAMES = ["name", "email", "phone"] as const;

export const toVariableName = (title: string): string =>
  title
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

export const createEmptyField = (): ContactPackField => ({
  title: "",
  type: "text",
  required: true,
  variable_name: "",
});
